var map = {
	"./de/btn-detail.png": "ih4F",
	"./en/btn-detail.png": "sgzC",
	"./es/btn-detail.png": "fJJI",
	"./fr/btn-detail.png": "xvjj",
	"./ja/btn-detail.png": "01ry",
	"./ko/btn-detail.png": "oGW8",
	"./pt/btn-detail.png": "fnle",
	"./ru/btn-detail.png": "rHP1",
	"./th/btn-detail.png": "jK0i",
	"./zh-Hant/btn-detail.png": "hiZQ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "x+tq";